import React from 'react'

// NOTE: reusable hook to fetch the data from the server
// by fetchHandler function (remember to pass a memoized
// version of fetchHandler to avoid infinite loop),
// it also allows to use it as a local state storage,
// the state can be also mutated with exposed handlers
export const useFetch = fetchHandler => {
  const [error, setError] = React.useState(null)
  const [meta, setMeta] = React.useState(null)
  const [response, setResponse] = React.useState(null)
  const [isFetching, setIsFetching] = React.useState(true)

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        setIsFetching(true)

        const { meta, response } = await fetchHandler()

        setMeta(meta)
        setResponse(response)
      } catch (error) {
        setError(error)
      } finally {
        setIsFetching(false)
      }
    }

    fetchData()
  }, [fetchHandler])

  return {
    state: { error, meta, response, isFetching },
    handlers: {
      handleSetError: setError,
      handleSetMeta: setMeta,
      handleSetResponse: setResponse,
    },
  }
}
